import { departmentMap } from '@/api';
import { get } from '@/common/request';

interface TreeNode {
  children: TreeNode[]
desc?: string | null;
encode?: string;
gmtCreate? : string;
gmtModified?: string;
id?: number;
manager?: null;
name?: string;
parent?: TreeNode;
null
}

class DepartmentStore {
  getTreeList (): Promise<TreeNode[]> {
    return get(departmentMap.get('treeList'), {}, { proxyApi: '/mirage', needHint: true });
  }
}

export default new DepartmentStore();
